import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CustomTable from '../../../components/customTable';
import getEnvironement from '../../../../environnement';
import CustomBackdrop from '../../../../components/backdrop';
import CustomSelect from '../../../../components/customSelect';
import ResumeDialog from './components/resumeDialog';
import DeleteDialog from './components/deleteDialog';
import StatutDialog from './components/statutDialog';
import CustomButton from '../../../../components/customButton';

export default function InscriptionAtelier() {
  const [chercherTypeInscription, setChercherTypeInscriptions] = useState('');
  const [inscriptions, setInscriptionsAtelier] = useState([]);
  const [filtredInscription, setFiltredInscription] = useState(inscriptions);
  const [selectedInscription, setSelectedInscription] = useState();
  // const [openResumeDialog, setOpenResumeDialog] = useState(false);
  // const [openStatutDialog, setOpenStatutDialog] = useState(false);
  // const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const getInscriptionsAtelier = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/getAllInscriptionsAtelier`;
    await axios.post(url)
      .then((res) => setInscriptionsAtelier(res.data.inscriptions))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, []);

  useEffect(() => {
    setFiltredInscription(inscriptions);
  }, [inscriptions]);

  useEffect(() => {
    getInscriptionsAtelier();
  }, [getInscriptionsAtelier]);

  return (
    <div className='flex flex-col h-full'>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      {/* <StatutDialog
        open={openStatutDialog}
        handleClose={() => setOpenStatutDialog(false)}
        reloadData={getSoumissions}
        soumission={selectedSoumission}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getSoumissions}
        soumission={selectedSoumission}
      />
      <ResumeDialog
        open={openResumeDialog}
        handleClose={() => setOpenResumeDialog(false)}
        soumission={selectedSoumission}
      /> */}
      <CustomSelect
        items={[
          {id: 0, value: '', label: 'Toutes les inscriptions'},
          {id: 1, value: 'étudiant', label: 'étudiant'},
          {id: 2, value: 'résident', label: 'résident'},
          {id: 3, value: 'spécialiste', label: 'spécialiste'},
        ]}
        placeholder={'Chercher par type d\'inscrit'}
        value={chercherTypeInscription}
        setValue={(content) => {
          console.log(content);
          if (content === '') {
            setFiltredInscription(inscriptions);
          } else {
            if (content === 'étudiant') {
              setFiltredInscription(inscriptions.filter(inscriptions => inscriptions.typeInscrit === 'étudiant'));
            } else if (content === 'résident') {
              setFiltredInscription(inscriptions.filter(inscriptions => inscriptions.typeInscrit === 'résident'));
            } else if (content === 'spécialiste') {
              setFiltredInscription(inscriptions.filter(inscriptions => inscriptions.typeInscrit === 'spécialiste'));
            } else {
              setFiltredInscription(inscriptions.filter(inscriptions => inscriptions.typeSoumission === content));
            }
          }
          setChercherTypeInscriptions(content)}}
        isError
      />
      <div className='flex-grow h-[48vh]'>
        <CustomTable
          headers={[
            `ID (${filtredInscription.length})`,
            'Type inscrit',
            'Nom',
            'E-mail',
            'Tel',
            'Date inscription',
            'Atelier 1',
            'Atelier 2',
            'Atelier 3',
            'Atelier 4',
            'Ateliers procéduraux',
          ]}
          config
        >
          <tbody>
            {
              filtredInscription.map((item, index) => {
                return (
                  <tr key={index} className='border-b-2 border-gray'>
                    <td className='text-center font-medium text-xl py-2'>{item.id}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.typeInscrit}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.nom}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.email}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.tel}</td>
                    <td className='text-center font-medium text-xl py-2'>{new Date(item.created_at).toISOString().split('T')[0]}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.atelier1}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.atelier2}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.atelier3}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.atelier4}</td>
                    <td className='text-center font-medium text-xl py-2'>{item.atelierProceduraux}</td>
                  </tr>
                );
              })
            }
            {filtredInscription.length === 0 && (
              <div className='border-dashed border-4 border-primary rounded-[30px] p-5 hidden xl:inline-block fixed mx-10 my-8 w-[65vw] md:w-[80vw] lg:w-[85vw] 3xl:w-[1100px]'>
                <p className='font-inter text-primary font-bold text-xl text-center'>
                  {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucune inscriptions'}
                </p>
              </div>
            )}
          </tbody>
        </CustomTable>
        <br />
        <CustomButton
          value='Télécharger la liste des inscriptions'
          admin
          handelClick={() => window.location.href = `${getEnvironement().API_URL}/getAllInscriptionsAtelierExcel`}
        />
        <br />
      </div>
    </div>
  );
}
